var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { fetchProjectNotes, createProjectNote, deleteProjectNote, fetchProjectTasks, createProjectTask, updateProjectTask, deleteProjectTask, } from '@/lib/api';
import { useI18n } from '@/lib/i18n';
import * as styles from './ProjectModal.module.scss';
export var ProjectModal = function (_a) {
    var clientId = _a.clientId, project = _a.project, onClose = _a.onClose, onSubmit = _a.onSubmit, onUpdate = _a.onUpdate, onDelete = _a.onDelete;
    var t = useI18n().t;
    var isEdit = !!project;
    var statusOptions = [
        { value: 'brief', label: t.statusBrief },
        { value: 'in_progress', label: t.statusInProgress },
        { value: 'review', label: t.statusReview },
        { value: 'done', label: t.statusDone },
    ];
    var _b = useState((project === null || project === void 0 ? void 0 : project.name) || ''), name = _b[0], setName = _b[1];
    var _c = useState((project === null || project === void 0 ? void 0 : project.status) || 'brief'), status = _c[0], setStatus = _c[1];
    var _d = useState((project === null || project === void 0 ? void 0 : project.progress) || 0), progress = _d[0], setProgress = _d[1];
    var _e = useState((project === null || project === void 0 ? void 0 : project.deadline) || ''), deadline = _e[0], setDeadline = _e[1];
    var _f = useState((project === null || project === void 0 ? void 0 : project.description) || ''), description = _f[0], setDescription = _f[1];
    var _g = useState((project === null || project === void 0 ? void 0 : project.priority) || 'normal'), priority = _g[0], setPriority = _g[1];
    var _h = useState(false), showDeleteConfirm = _h[0], setShowDeleteConfirm = _h[1];
    var _j = useState([]), notes = _j[0], setNotes = _j[1];
    var _k = useState(''), newNote = _k[0], setNewNote = _k[1];
    var _l = useState(true), noteVisible = _l[0], setNoteVisible = _l[1];
    var _m = useState(false), addingNote = _m[0], setAddingNote = _m[1];
    var _o = useState([]), tasks = _o[0], setTasks = _o[1];
    var _p = useState(''), newTaskText = _p[0], setNewTaskText = _p[1];
    var _q = useState(false), addingTask = _q[0], setAddingTask = _q[1];
    useEffect(function () { if (isEdit && project) {
        loadNotes(project.id);
        loadTasks(project.id);
    } }, [project === null || project === void 0 ? void 0 : project.id]);
    var loadNotes = function (projectId) { return __awaiter(void 0, void 0, void 0, function () { var _a, err_1; return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                _a = setNotes;
                return [4 /*yield*/, fetchProjectNotes(projectId)];
            case 1:
                _a.apply(void 0, [_b.sent()]);
                return [3 /*break*/, 3];
            case 2:
                err_1 = _b.sent();
                console.error(err_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    }); }); };
    var handleAddNote = function () { return __awaiter(void 0, void 0, void 0, function () {
        var note_1, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!newNote.trim() || !project)
                        return [2 /*return*/];
                    setAddingNote(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, createProjectNote({ projectId: project.id, text: newNote.trim(), visibleToClient: noteVisible })];
                case 2:
                    note_1 = _a.sent();
                    setNotes(function (prev) { return __spreadArray([note_1], prev, true); });
                    setNewNote('');
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _a.sent();
                    console.error(err_2);
                    return [3 /*break*/, 5];
                case 4:
                    setAddingNote(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteNote = function (noteId) { return __awaiter(void 0, void 0, void 0, function () { var err_3; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, deleteProjectNote(noteId)];
            case 1:
                _a.sent();
                setNotes(function (prev) { return prev.filter(function (n) { return n.id !== noteId; }); });
                return [3 /*break*/, 3];
            case 2:
                err_3 = _a.sent();
                console.error(err_3);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    }); }); };
    var loadTasks = function (projectId) { return __awaiter(void 0, void 0, void 0, function () { var _a, err_4; return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                _a = setTasks;
                return [4 /*yield*/, fetchProjectTasks(projectId)];
            case 1:
                _a.apply(void 0, [_b.sent()]);
                return [3 /*break*/, 3];
            case 2:
                err_4 = _b.sent();
                console.error(err_4);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    }); }); };
    var handleAddTask = function () { return __awaiter(void 0, void 0, void 0, function () {
        var task, updated, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!newTaskText.trim() || !project)
                        return [2 /*return*/];
                    setAddingTask(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, createProjectTask({ projectId: project.id, text: newTaskText.trim(), position: tasks.length })];
                case 2:
                    task = _a.sent();
                    updated = __spreadArray(__spreadArray([], tasks, true), [task], false);
                    setTasks(updated);
                    setNewTaskText('');
                    recalcProgress(updated);
                    return [3 /*break*/, 5];
                case 3:
                    err_5 = _a.sent();
                    console.error(err_5);
                    return [3 /*break*/, 5];
                case 4:
                    setAddingTask(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleToggleTask = function (task) { return __awaiter(void 0, void 0, void 0, function () {
        var updated, err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, updateProjectTask(task.id, { done: !task.done })];
                case 1:
                    _a.sent();
                    updated = tasks.map(function (t2) { return t2.id === task.id ? __assign(__assign({}, t2), { done: !t2.done }) : t2; });
                    setTasks(updated);
                    recalcProgress(updated);
                    return [3 /*break*/, 3];
                case 2:
                    err_6 = _a.sent();
                    console.error(err_6);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteTask = function (taskId) { return __awaiter(void 0, void 0, void 0, function () {
        var updated, err_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, deleteProjectTask(taskId)];
                case 1:
                    _a.sent();
                    updated = tasks.filter(function (t2) { return t2.id !== taskId; });
                    setTasks(updated);
                    recalcProgress(updated);
                    return [3 /*break*/, 3];
                case 2:
                    err_7 = _a.sent();
                    console.error(err_7);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleTaskKeyDown = function (e) { if (e.key === 'Enter') {
        e.preventDefault();
        handleAddTask();
    } };
    var recalcProgress = function (taskList) { if (taskList.length === 0)
        return; setProgress(Math.round((taskList.filter(function (t2) { return t2.done; }).length / taskList.length) * 100)); };
    var handleSubmit = function () {
        if (!name.trim())
            return;
        if (isEdit && onUpdate && project)
            onUpdate(project.id, { name: name, status: status, progress: progress, deadline: deadline, description: description, priority: priority });
        else
            onSubmit({ clientId: clientId, name: name, status: status, progress: progress, deadline: deadline, description: description, priority: priority });
        onClose();
    };
    var handleDelete = function () { if (project && onDelete) {
        onDelete(project.id);
        onClose();
    } };
    var handleKeyDown = function (e) { if (e.key === 'Enter' && !e.shiftKey && e.target instanceof HTMLInputElement)
        handleSubmit(); };
    var handleStatusChange = function (newStatus) { setStatus(newStatus); };
    var formatNoteDate = function (d) {
        var date = new Date(d);
        return date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' }) + ' ' + date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
    };
    var doneCount = tasks.filter(function (t2) { return t2.done; }).length;
    return (_jsx("div", { className: styles.overlay, onClick: onClose, children: _jsxs("div", { className: styles.modal, onClick: function (e) { return e.stopPropagation(); }, children: [_jsxs("div", { className: styles.modalBody, children: [_jsx("div", { className: styles.title, children: isEdit ? t.editProject : t.newProject }), _jsx("label", { className: styles.label, children: t.projectName }), _jsx("input", { className: styles.input, placeholder: t.projectNamePlaceholder, value: name, onChange: function (e) { return setName(e.target.value); }, onKeyDown: handleKeyDown, autoFocus: true }), _jsx("label", { className: styles.label, children: t.description }), _jsx("textarea", { className: styles.textarea, placeholder: t.descriptionPlaceholder, value: description, onChange: function (e) { return setDescription(e.target.value); }, rows: 3 }), _jsxs("div", { className: styles.rowFields, children: [_jsxs("div", { className: styles.fieldHalf, children: [_jsx("label", { className: styles.label, children: t.status }), _jsx("div", { className: styles.statusGrid, children: statusOptions.map(function (opt) { return (_jsx("button", { type: "button", className: "".concat(styles.statusOption, " ").concat(status === opt.value ? styles.statusActive : ''), onClick: function () { return handleStatusChange(opt.value); }, children: opt.label }, opt.value)); }) })] }), _jsxs("div", { className: styles.fieldHalf, children: [_jsx("label", { className: styles.label, children: t.priority }), _jsxs("div", { className: styles.priorityGrid, children: [_jsx("button", { type: "button", className: "".concat(styles.priorityOption, " ").concat(priority === 'normal' ? styles.priorityNormal : ''), onClick: function () { return setPriority('normal'); }, children: t.priorityNormal }), _jsx("button", { type: "button", className: "".concat(styles.priorityOption, " ").concat(priority === 'urgent' ? styles.priorityUrgent : ''), onClick: function () { return setPriority('urgent'); }, children: t.priorityUrgent })] })] })] }), tasks.length > 0 ? (_jsxs("div", { className: styles.autoProgressBar, children: [_jsx("div", { className: styles.autoProgressLabel, children: t.progressAuto(doneCount, tasks.length, progress) }), _jsx("div", { className: styles.autoProgressTrack, children: _jsx("div", { className: styles.autoProgressFill, style: { width: progress + '%' } }) })] })) : (_jsxs(_Fragment, { children: [_jsxs("label", { className: styles.label, children: [t.progress, ": ", progress, "%"] }), _jsx("input", { className: styles.range, type: "range", min: 0, max: 100, value: progress, onChange: function (e) { return setProgress(Number(e.target.value)); } })] })), _jsx("label", { className: styles.label, children: t.deadline }), _jsx("input", { className: styles.input, type: "date", value: deadline, onChange: function (e) { return setDeadline(e.target.value); }, onKeyDown: handleKeyDown }), isEdit && (_jsxs("div", { className: styles.tasksSection, children: [_jsx("div", { className: styles.tasksSectionHeader, children: _jsxs("span", { className: styles.label, style: { marginBottom: 0 }, children: [t.tasks, " (", doneCount, "/", tasks.length, ")"] }) }), _jsxs("div", { className: styles.taskInput, children: [_jsx("input", { className: styles.taskInputField, placeholder: t.addTask, value: newTaskText, onChange: function (e) { return setNewTaskText(e.target.value); }, onKeyDown: handleTaskKeyDown }), _jsx("button", { className: styles.taskAddBtn, onClick: handleAddTask, disabled: !newTaskText.trim() || addingTask, children: "+" })] }), _jsxs("div", { className: styles.tasksList, children: [tasks.map(function (tk) { return (_jsxs("div", { className: "".concat(styles.taskItem, " ").concat(tk.done ? styles.taskDone : ''), children: [_jsx("button", { className: tk.done ? styles.taskCheckDone : styles.taskCheck, onClick: function () { return handleToggleTask(tk); }, children: tk.done ? '✓' : '' }), _jsx("span", { className: tk.done ? styles.taskTextDone : styles.taskText, children: tk.text }), _jsx("button", { className: styles.taskDeleteBtn, onClick: function () { return handleDeleteTask(tk.id); }, children: "\u2715" })] }, tk.id)); }), tasks.length === 0 && _jsx("div", { className: styles.tasksEmpty, children: t.tasksEmpty })] })] })), isEdit && (_jsxs("div", { className: styles.notesSection, children: [_jsx("div", { className: styles.notesHeader, children: _jsxs("span", { className: styles.label, style: { marginBottom: 0 }, children: [t.notes, " (", notes.length, ")"] }) }), _jsxs("div", { className: styles.noteInput, children: [_jsx("textarea", { className: styles.noteTextarea, placeholder: t.writeNote, value: newNote, onChange: function (e) { return setNewNote(e.target.value); }, rows: 2 }), _jsxs("div", { className: styles.noteActions, children: [_jsxs("label", { className: styles.visibilityToggle, children: [_jsx("input", { type: "checkbox", checked: noteVisible, onChange: function (e) { return setNoteVisible(e.target.checked); } }), _jsx("span", { className: styles.visibilityLabel, children: noteVisible ? t.visibleToClient : t.privateNote })] }), _jsx("button", { className: styles.addNoteBtn, onClick: handleAddNote, disabled: !newNote.trim() || addingNote, children: addingNote ? '...' : "+ ".concat(t.add) })] })] }), _jsxs("div", { className: styles.notesList, children: [notes.map(function (n) { return (_jsxs("div", { className: styles.noteItem, children: [_jsx("div", { className: styles.noteText, children: n.text }), _jsxs("div", { className: styles.noteMeta, children: [_jsx("span", { children: formatNoteDate(n.created_at) }), _jsx("span", { className: n.visible_to_client ? styles.noteVisible : styles.notePrivate, children: n.visible_to_client ? t.clientSees : t.privateLabel }), _jsx("button", { className: styles.noteDeleteBtn, onClick: function () { return handleDeleteNote(n.id); }, children: "\u2715" })] })] }, n.id)); }), notes.length === 0 && _jsx("div", { className: styles.notesEmpty, children: t.noNotes })] })] }))] }), _jsxs("div", { className: styles.actions, children: [isEdit && onDelete && (_jsx(_Fragment, { children: showDeleteConfirm ? (_jsxs("div", { className: styles.deleteConfirm, children: [_jsx("span", { className: styles.deleteText, children: t.deleteProject }), _jsx("button", { className: styles.deleteConfirmBtn, onClick: handleDelete, children: t.yes }), _jsx("button", { className: styles.cancelBtn, onClick: function () { return setShowDeleteConfirm(false); }, children: t.no })] })) : (_jsxs("button", { className: styles.deleteBtn, onClick: function () { return setShowDeleteConfirm(true); }, children: ["\uD83D\uDDD1 ", t.delete] })) })), _jsx("div", { className: styles.actionsSpacer }), _jsx("button", { className: styles.cancelBtn, onClick: onClose, children: t.cancel }), _jsx("button", { className: styles.submitBtn, onClick: handleSubmit, children: isEdit ? t.save : t.create })] })] }) }));
};
